<template>
  <div style="position: relative;width: 100%; height: 100%;">
<h1>222</h1>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "index",
  data() {
    return {

    };
  },
  methods: {

  },
  created() {

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only 1597980855  -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/goods.vue